<template>
	<div class="popup-menu">
		<VButton
			v-if="!hideEdit"
			@click="onEditButtonClick"
		>
			<template #icon>
				<VIcon material="open_in_new" theme="outlined" />
			</template>
			Открыть
		</VButton>

		<hr v-if="!hideEdit">

		<VButton @click="onHistoryButtonClick">
			<template #icon>
				<VIcon material="history" theme="outlined" />
			</template>
			История
		</VButton>

		<VButton
			:disabled="Boolean(store.getReasonCannotSetAsDraft())"
			:title="store.getReasonCannotSetAsDraft()"
			@click="onSetAsDraftButtonClick"
		>
      <template #icon>
        <VIcon material="draw" theme="outlined" />
      </template>
			Пометить как черновик
		</VButton>

		<VButton
			:disabled="Boolean(store.getReasonCannotApprove())"
			:title="store.getReasonCannotApprove()"
			@click="onApproveButtonClick"
		>
      <template #icon>
        <VIcon material="check_circle" theme="outlined" />
      </template>
			Утвердить
		</VButton>

		<hr>

		<VButton @click="onDeleteButtonClick">
			<template #icon>
				<VIcon material="delete" theme="outlined" />
			</template>
			Удалить
		</VButton>
	</div>
</template>

<script lang="ts">
import Store         from '@/domains/Stores/Store';
import StoresService from '@/domains/Stores/StoresService';

export default defineComponent({
	name: 'StoresContextMenu',

	props: {
		store: {
			type:     Store,
			required: true,
		},
		/** true когда меню открыто внутри уже открытой карточки склада */
		hideEdit: {
			type:    Boolean,
			default: false,
		},
	},

	emits: [
		Store.Events.Updated,
		Store.Events.Deleted,
		'hide',
	],

	methods: {
		onEditButtonClick() {
			this.$emit('hide');

			StoresService.editStore(
				this.store,
				() => this.$emit(Store.Events.Updated),
			);
		},

		onHistoryButtonClick() {
			this.$emit('hide');

			this.$core.dialogs.FeedDialog.show({
				entityTypeName: 'store',
				entityId:       this.store.id,
				showAddComment: false,
			});
		},

		async onSetAsDraftButtonClick() {
			this.$emit('hide');
			await this.changeDraftStatus(true);
		},

		async onApproveButtonClick() {
			this.$emit('hide');
			await this.changeDraftStatus(false);
		},

		async onDeleteButtonClick() {
			this.$emit('hide');

			const success = await StoresService.deleteWithConfirmation(this.store);
			if (success) {
				this.$emit(Store.Events.Deleted);
			}
		},

		/**
		 * Общая логика для approve / setAsDraft — клонируем, меняем флаг, обновляем.
		 * Карточка слушает Updated и закрывается сама (см. StoreCard.onUpdated).
		 */
		async changeDraftStatus(isDraft: boolean) {
			const localStore = this.$core.utils.cloneDeep(this.store);
			localStore.isDraft = isDraft;

			const success = await StoresService.update(localStore);
			if (success) {
				this.$emit(Store.Events.Updated);
			}
		},
	},
});
</script>
